import React from "react";
import { useTranslation } from "react-i18next";
import Seo from "../seo/Seo";
import TodoText from "../components/TodoText";
import { ORG } from "../seo/site";
import "../styles/Legal.css";

const Company = () => {
  const { t } = useTranslation();
  const rows = t("company.rows", { returnObjects: true });

  return (
    <div className="legal-page">
      <Seo page="company" path="/company" />

      <section className="legal-hero">
        <div className="container">
          <h1>{t("company.title")}</h1>
          <p className="legal-lead">{t("company.lead")}</p>
        </div>
      </section>

      <section className="legal-body">
        <div className="container">
          <div className="legal-section">
            <h2>{t("company.registrationTitle")}</h2>
            <dl className="legal-facts">
              {rows.map((row, i) => (
                <div className="legal-fact" key={i}>
                  <dt>{row.k}</dt>
                  <dd><TodoText>{row.v}</TodoText></dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="legal-section">
            <h2>{t("company.contactTitle")}</h2>
            <p>{t("company.contactText")}</p>
            <ul className="legal-list">
              <li>
                <strong>Email</strong> — <a href={`mailto:${ORG.email}`}>{ORG.email}</a>
              </li>
              <li>
                <strong>Web</strong> — <a href="https://malilabs.com">malilabs.com</a>
              </li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>{t("company.officeTitle")}</h2>
            <p>{t("company.officeText")}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Company;
